import { Error } from "../../../../types/errors";

export const initialError: Error = { type: "", message: "" };
